export default "__VITE_ASSET__JQOQABrI__"